var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('i',{staticClass:"el-icon-question"}),_c('h1',[_vm._v("Page not Found!")]),_c('p',{staticClass:"text-center"},[_c('el-link',{attrs:{"href":_vm.oldPath},domProps:{"textContent":_vm._s(_vm.oldPath)}}),_c('br'),_vm._v("\n    Please coordinate with your system administrator.\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }